export const enum Environments {
  LIVE_PRODUCTION = 'Production',
  QA = 'QA',
  DEV = 'Development',
  // TEST environment is not included here because we want TEST to look like DEV
}
